<template>
  <div>
    <a-card
      size="small"
      title="查询"
      :headStyle="{
        background: '#f3f3f3',
      }"
    >
      <a-form layout="inline">
        <a-form-item>
          <a-input
            placeholder="菜单名称"
            v-model:value="searchForm.menuName"
            allowClear
            @keyup.enter.native="searchAction()"
          />
        </a-form-item>

        <a-form-item>
          <a-button type="primary" @click="searchAction"> 查询</a-button>
        </a-form-item>
        <a-form-item>
          <a-button @click="reset">重置</a-button>
        </a-form-item>
        <a-form-item></a-form-item>
      </a-form>
    </a-card>

    <a-card
      size="small"
      title="菜单列表"
      style="margin-top: 20px"
      :headStyle="{
        background: '#f3f3f3',
      }"
      :bodyStyle="{
        padding: '0',
      }"
    >
      <template v-slot:extra>
        <a-button
          @click="toAdd"
          type="primary"
          v-has-permi="['system:menu:add']"
          >添加</a-button
        >
      </template>

      <a-table
        :columns="columns"
        bordered
        :data-source="list"
        :row-key="(r) => r.menuId"
        :loading="loading"
        style="overflow-y:scroll"
      >
        <template v-slot:icon="{ text, record, index }">
          <icon-font :type="record.icon" />
        </template>

        <template v-slot:button="{ text, record }">
          <a-button
            type="primary"
            @click="edit(record)"
            v-has-permi="['system:menu:edit']"
          >
            编辑</a-button
          >
        </template>
      </a-table>
    </a-card>

    <!--    <df-pagination :model="pageObj"></df-pagination>-->

    <a-modal
      v-model:visible="modalVisible"
      title="添加菜单"
      @ok="handleOk"
      :destroyOnClose="true"
    >
      <!-- @ok="handleOk" -->
      <a-form
        layout="horizontal"
        :ref="setsubmitForm"
        :model="submitForm"
        :rules="rules"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
      >
        <a-form-item label="上级菜单" name="parentId">
          <df-selectMenuTreeSingle
            :model="submitForm"
            @setValue="setValue"
            style="width: 282px"
          />
        </a-form-item>
        <a-form-item label="菜单类型" name="menuType">
          <a-radio-group
            v-model:value="submitForm.menuType"
            button-style="solid"
            default-value="M"
            @change="menuTypeChange"
          >
            <a-radio-button value="M"> 目录</a-radio-button>
            <a-radio-button value="C"> 菜单</a-radio-button>
            <a-radio-button value="F"> 按钮</a-radio-button>
          </a-radio-group>
        </a-form-item>
        <a-form-item label="菜单图标" name="icon" v-if="!isButton">
          <a-input
            v-model:value="submitForm.icon"
            placeholder="菜单图标"
            style="width: 282px"
          />
        </a-form-item>
        <a-form-item label="菜单名称" name="menuName">
          <a-input
            v-model:value="submitForm.menuName"
            placeholder="菜单名称"
            style="width: 282px"
          />
        </a-form-item>
        <a-form-item
          label="路由地址"
          name="component"
          v-if="!isButton && !isCatalogue"
        >
          <a-input
            v-model:value="submitForm.component"
            placeholder="路由地址"
            style="width: 282px"
          />
        </a-form-item>
        <a-form-item
          label="组件路径"
          name="path"
          v-if="!isButton && !isCatalogue"
        >
          <a-input
            v-model:value="submitForm.path"
            placeholder="组件路径"
            style="width: 282px"
          />
        </a-form-item>
        <a-form-item label="权限标识" name="perms">
          <a-input
            v-model:value="submitForm.perms"
            placeholder="权限标识"
            style="width: 282px"
          />
        </a-form-item>
        <a-form-item label="菜单排序" name="orderNum">
          <a-input-number
            v-model:value="submitForm.orderNum"
            placeholder="排序"
            :min="1"
            :max="100"
            style="width: 282px"
          />
        </a-form-item>
        <a-form-item label="菜单状态" name="main" v-if="!isButton">
          <a-radio-group
            v-model:value="submitForm.status"
            button-style="solid"
            default-value="0"
          >
            <a-radio-button value="0"> 开启</a-radio-button>
            <a-radio-button value="1"> 关闭</a-radio-button>
          </a-radio-group>
        </a-form-item>
        <a-form-item label="是否外链" name="main" v-if="!isButton">
          <a-radio-group
            v-model:value="submitForm.isFrame"
            button-style="solid"
            default-value="0"
          >
            <a-radio-button value="0"> 是</a-radio-button>
            <a-radio-button value="1"> 否</a-radio-button>
          </a-radio-group>
        </a-form-item>
        <a-form-item label="显示状态" name="main" v-if="!isButton">
          <a-radio-group
            v-model:value="submitForm.visible"
            button-style="solid"
            default-value="0"
          >
            <a-radio-button value="0"> 显示</a-radio-button>
            <a-radio-button value="1"> 隐藏</a-radio-button>
          </a-radio-group>
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import menuApi from "@axios/sys/menu";
import staticof from "@assets/static";
import { ref, reactive, provide } from "vue";
import { notification } from "ant-design-vue";
import { SmileOutlined } from "@ant-design/icons-vue";
import moment from "moment";
import { createFromIconfontCN } from "@ant-design/icons-vue";

const IconFont = createFromIconfontCN({
  scriptUrl: "//at.alicdn.com/t/font_2033419_extitw862n.js",
});
export default {
  name: "menuIndex",
  components: {
    IconFont,
  },
  setup() {
    let submitFormref = "";
    const setsubmitForm = (el) => {
      submitFormref = el;
    };

    let submitForm = reactive({
      parentId: "",
      menuName: "",
      path: "",
      component: "",
      menuType: "M",
      perms: "",
      icon: "",
      status: "0",
      isFrame: "1",
      visible: "0",
      orderNum: "1",
    });
    //目录
    let isCatalogue = ref(true);
    //菜单
    let isMenu = ref(false);
    //按钮
    let isButton = ref(false);
    //切换菜单类型
    const menuTypeChange = (e) => {
      typeChange(e.target.value);
    };
    //切换（M目录 C菜单 F按钮）
    const typeChange = (menuType) => {
      if (menuType == "M") {
        isCatalogue.value = true;
        isMenu.value = false;
        isButton.value = false;
      }
      if (menuType == "C") {
        isCatalogue.value = false;
        isMenu.value = true;
        isButton.value = false;
      }
      if (menuType == "F") {
        isCatalogue.value = false;
        isMenu.value = false;
        isButton.value = true;
      }
    };

    const rules = {
      menuName: [
        { required: true, message: "请输入菜单名称", trigger: "blur" },
      ],
      component: [
        { required: true, message: "请输入权限字符", trigger: "blur" },
      ],
    };

    let loading = ref(false);
    let modalVisible = ref(false);
    let searchForm = reactive({
      menuName: "",
    });
    let searchParams = reactive({
      menuName: "",
    });

    let names = ref("");

    let list = ref([]);

    const columns = [
      {
        title: "菜单名称",
        dataIndex: "menuName",
        width: 200,
      },
      {
        title: "图标",
        dataIndex: "icon",
        width: 200,
        align: "center",
        slots: { customRender: "icon" },
      },
      {
        title: "菜单排序",
        dataIndex: "orderNum",
        width: 100,
        align: "center",
      },
      {
        title: "权限标识",
        dataIndex: "perms",
        width: 200,
        align: "center",
      },
      {
        title: "组件路径",
        dataIndex: "path",
        width: 200,
        align: "center",
      },
      {
        title: "状态",
        dataIndex: "statusValue",
        width: 200,
        align: "center",
      },
      {
        title: "创建时间",
        dataIndex: "createTime",
        width: 200,
        align: "center",
      },
      {
        title: "操作",
        dataIndex: "createTime",
        width: 100,
        align: "center",
        slots: { customRender: "button" },
      },
    ];

    const searchAction = () => {
      searchParams.menuName = searchForm.menuName;
      console.log(searchParams);
      getList();
    };
    //查询列表
    const getList = () => {
      loading.value = true;
      let params = {
        menuName: searchParams.menuName ? searchParams.menuName : null,
      };
      menuApi.menuList(params).then((res) => {
        loading.value = false;
        if (!res) return;
        list.value = res;
      });
    };

    const reset = () => {
      searchForm.menuName = "";
      searchAction();
    };

    const toAdd = () => {
      modalVisible.value = true;
      isedit.value = false;
      isCatalogue.value = true;
      isMenu.value = false;
      isButton.value = false;
      submitForm.parentId = "0";
      submitForm.menuName = "";
      submitForm.status = "0";
      submitForm.isFrame = "1";
      submitForm.visible = "0";
      submitForm.path = "";
      submitForm.menuType = "M";
      submitForm.perms = "";
      submitForm.icon = "";
      submitForm.orderNum = "1";
    };

    const handleOk = () => {
      submitFormref
        .validate()
        .then(() => {
          //添加账号
          if (isedit.value) {
            let params = {
              menuId: editid,
              parentId: submitForm.parentId,
              menuName: submitForm.menuName,
              status: submitForm.status,
              isFrame: submitForm.isFrame,
              visible: submitForm.visible,
              path: submitForm.path,
              menuType: submitForm.menuType,
              perms: submitForm.perms,
              icon: submitForm.icon,
              orderNum: submitForm.orderNum,
            };
            menuApi.menuEdit(params).then((res) => {
              modalVisible.value = false;
              getList();
              notification.open({
                message: "编辑成功",
                icon: <SmileOutlined style="color: #108ee9" />,
              });
            });
          } else {
            console.log(JSON.stringify(submitForm));
            menuApi.addMenu(submitForm).then((res) => {
              modalVisible.value = false;
              getList();
              notification.open({
                message: "添加成功",
                icon: <SmileOutlined style="color: #108ee9" />,
              });
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    };

    //上级菜单值
    const setValue = (val) => {
      console.log(val);
      submitForm.parentId = val;
    };

    let isedit = ref(false);
    let editid = "";
    const edit = (row) => {
      if (submitFormref) submitFormref.resetFields();
      editid = row.menuId;
      isedit.value = true;
      modalVisible.value = true;
      submitForm.parentId = row.parentId;
      submitForm.menuName = row.menuName;
      submitForm.status = row.status;
      submitForm.isFrame = row.isFrame;
      submitForm.visible = row.visible;
      submitForm.path = row.path;
      submitForm.menuType = row.menuType;
      submitForm.perms = row.perms;
      submitForm.icon = row.icon;
      submitForm.orderNum = row.orderNum;
      typeChange(row.menuType);
    };

    getList();

    return {
      isedit,
      edit,
      names,
      staticof,
      loading,
      searchForm,
      searchParams,
      list,
      columns,
      searchAction,
      reset,
      toAdd,
      modalVisible,
      moment,
      disabledDate(current) {
        return current && current < moment().endOf("day");
      },
      labelCol: { span: 4 },
      wrapperCol: { span: 20 },
      rules,
      submitForm,
      handleOk,
      setsubmitForm,
      setValue,
      menuTypeChange,
      isCatalogue,
      isMenu,
      isButton,
    };
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.table_logo {
  width: 70px;
}
</style>
